import { publicApi } from "./api";

// The option list is the same on every form — fetched once per page load so four
// forms on one journey don't ask four times.
let cache = null;

export const leadSourceOptions = () => {
  if (!cache) {
    cache = publicApi.leadSources()
      .then((d) => d.options || [])
      .catch(() => {
        cache = null;
        return [];
      });
  }
  return cache;
};

export const emptyLeadSource = { id: "", label: "", detail: "" };

/** The message to show, or "" when the answer is acceptable. */
export const leadSourceError = (value, options, required) => {
  const v = value || emptyLeadSource;
  if (!v.id) return required ? "Please let us know how you heard about us." : "";
  const opt = (options || []).find((o) => o.id === v.id);
  if (opt?.detail?.enabled && opt.detail.required && !String(v.detail || "").trim()) {
    return opt.detail.label || "Please add a little more detail.";
  }
  return "";
};

/** What gets sent with the form. Null when they didn't answer. */
export const leadSourcePayload = (value) => {
  const v = value || emptyLeadSource;
  if (!v.id) return null;
  return { id: v.id, label: v.label, detail: String(v.detail || "").trim() };
};
